// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1258":"30a0f5b7ed7806b9","2564":"fbb8914b0881a9a9","6851":"10639c56c77c02ea"}[chunkId] + ".css";
};